import { DtoBase } from "../../DtoBase";
import { AccountType } from "../UserDto";
import { HashSet } from "DiscoveryEngine.TS/Utils";
import { DirectoryGroupDto } from "./DirectoryGroupDto";


export class DirectoryUserDto extends DtoBase {

	private static readonly Default_AccountType = AccountType.Native;

	public AccountType: AccountType;
	public DomainName: string;
	public EphemeralId: string;
	public PermanentId: string;
	public Username: string;
	public Name: string;
	public Description: string;
	public FirstName: string;
	public LastName: string;
	public Email: string;
	// Not Serialized
	public ParentGroups: HashSet<DirectoryGroupDto>;

	constructor() {
		super();

		this.AccountType = DirectoryUserDto.Default_AccountType;
		this.DomainName = "";
		this.EphemeralId = "";
		this.PermanentId = "";
		this.Username = "";
		this.Name = "";
		this.Description = "";
		this.FirstName = "";
		this.LastName = "";
		this.Email = "";
		this.ParentGroups = new HashSet<DirectoryGroupDto>();
	}

	public get HasDomainName(): boolean {
		return !!this.DomainName;
	}

	public get HasEphemeralId(): boolean {
		return !!this.EphemeralId;
	}

	public get HasPermanentId(): boolean {
		return !!this.PermanentId;
	}

	public get HasUsername(): boolean {
		return !!this.Username;
	}

	public get HasName(): boolean {
		return !!this.Name;
	}

	public get HasDescription(): boolean {
		return !!this.Description;
	}

	public get HasFirstName(): boolean {
		return !!this.FirstName;
	}

	public get HasLastName(): boolean {
		return !!this.LastName;
	}

	public get HasEmail(): boolean {
		return !!this.Email;
	}

	public get HasParentGroups(): boolean {
		return (!!this.ParentGroups && this.ParentGroups.Count > 0);
	}

	public Write(obj: any, context: any): void {
		obj.directory_user = {};
		obj = obj.directory_user;

		super.Write(obj, context);

		if (this.AccountType !== DirectoryUserDto.Default_AccountType)
			obj.account_type = AccountType[this.AccountType];

		if (this.HasDomainName)
			obj.domain_name = this.DomainName;

		if (this.HasEphemeralId)
			obj.ephemeral_id = this.EphemeralId;

		if (this.HasPermanentId)
			obj.permanent_id = this.PermanentId;

		if (this.HasUsername)
			obj.user_name = this.Username;

		if (this.HasName)
			obj.name = this.Name;

		if (this.HasDescription)
			obj.description = this.Description;

		if (this.HasFirstName)
			obj.first_name = this.FirstName;

		if (this.HasLastName)
			obj.last_name = this.LastName;

		if (this.HasEmail)
			obj.email = this.Email;
	}

	public Read(obj: any, context: any): void {

		if (!obj.directory_user)
			throw new Error();
		obj = obj.directory_user;

		super.Read(obj, context);

		if (obj.account_type !== undefined)
			this.AccountType = AccountType[<string>obj.account_type];

		if (obj.domain_name !== undefined)
			this.DomainName = obj.domain_name;

		if (obj.ephemeral_id !== undefined)
			this.EphemeralId = obj.ephemeral_id;

		if (obj.permanent_id !== undefined)
			this.PermanentId = obj.permanent_id;

		if (obj.user_name !== undefined)
			this.Username = obj.user_name;

		if (obj.name !== undefined)
			this.Name = obj.name;

		if (obj.description !== undefined)
			this.Description = obj.description;

		if (obj.first_name !== undefined)
			this.FirstName = obj.first_name;

		if (obj.last_name !== undefined)
			this.LastName = obj.last_name;

		if (obj.email !== undefined)
			this.Email = obj.email;
	}

}